import screens from '../../config/screens';
import {DrawerItem} from '../../interfaces/router/drawerItem';
import {createLazyComponent} from '../../utils/lazyLoad';
import Patients from '../../screens/content/EHR/patients';
import {getStacksGroups} from '../../utils/router';
import ViewPatient from '../../screens/content/EHR/patients/viewPatient';
import AddEditPatient from '../../screens/content/EHR/patients/addEditPatient';
import AddEditPatientReport from '../../screens/content/EHR/patientReports/addEditPatientReport';
import ViewPatientReport from '../../screens/content/EHR/patientReports/viewPatientReport';
import Home from '../../screens/content/home';
import TabNews from '../../screens/content/tabNews';
import MedicalUpdatesCongresses from '../../screens/content/tabNews/medicalUpdatesCongresses';
import TabNewsResults from '../../screens/content/tabNews/tabNewsResults';
import FilterTabNews from '../../screens/content/tabNews/filterTabNews';
import DrugsDiseases from '../../screens/content/drugsDiseases';
import DrugsDiseasesDetails from '../../screens/content/drugsDiseases/drugsDiseasesDetails';
import AllTopics from '../../screens/content/home/allTopics';
import Chat from '../../screens/content/chat';
import ClinicalCase from '../../screens/content/clinicalCase';
import EnterClinicalCase from '../../screens/content/clinicalCase/enterClinicalCase';

// Create lazy loaded components
// const LazyHomeTabs = createLazyComponent(HomeTabs);
const LazyPatients = createLazyComponent(Patients);
const LazyViewPatient = createLazyComponent(ViewPatient);
const LazyAddEditPatient = createLazyComponent(AddEditPatient);
const LazyAddEditPatientReport = createLazyComponent(AddEditPatientReport);
const LazyViewPatientReport = createLazyComponent(ViewPatientReport);

const LazyHome = createLazyComponent(Home);
const LazyTabNews = createLazyComponent(TabNews);
const LazyMedicalUpdatesCongresses = createLazyComponent(
  MedicalUpdatesCongresses,
);
const LazyTabNewsResults = createLazyComponent(TabNewsResults);
const LazyFilterTabNews = createLazyComponent(FilterTabNews);
const LazyDrugsDiseases = createLazyComponent(DrugsDiseases);
const LazyDrugsDiseasesDetails = createLazyComponent(DrugsDiseasesDetails);
const LazyAllTopics = createLazyComponent(AllTopics);
const LazyChat = createLazyComponent(Chat);
const LazyClinicalCase = createLazyComponent(ClinicalCase);
const LazyEnterClinicalCase = createLazyComponent(EnterClinicalCase);
const EmptyRoutes = () => null;

const PatientsRoutes = () =>
  getStacksGroups([
    {
      name: screens.content.patients,
      component: LazyPatients,
    },
    {
      name: screens.content.viewPatient,
      component: LazyViewPatient,
    },
    {
      name: screens.content.addEditPatient,
      component: LazyAddEditPatient,
    },
    {
      name: screens.content.viewPatientReport,
      component: LazyViewPatientReport,
    },
    {
      name: screens.content.addEditPatientReport,
      component: LazyAddEditPatientReport,
    },
  ]);

const ChatRoutes = () =>
  getStacksGroups([
    {
      name: screens.content.genioChat,
      component: LazyChat,
      options: {
        headerShown: false,
      },
    },
    {
      name: screens.content.enterClinicalCase,
      component: LazyEnterClinicalCase,
    },
  ]);

const ClinicalCaseRoutes = () =>
  getStacksGroups([
    {
      name: screens.content.clinicalCase,
      component: LazyClinicalCase,
      options: {
        animation: 'slide_from_bottom',
      },
    },
  ]);

const HomeRoutes = () =>
  getStacksGroups([
    {
      name: screens.content.home,
      component: LazyHome,
      options: {
        headerShown: false,
        animation: 'none',
      },
    },
    {
      name: screens.content.tabNews,
      component: LazyTabNews,
    },
    {
      name: screens.content.medicalUpdatesCongresses,
      component: LazyMedicalUpdatesCongresses,
    },
    {
      name: screens.content.tabNewsResults,
      component: LazyTabNewsResults,
    },
    {
      name: screens.content.filterTabNews,
      component: LazyFilterTabNews,
    },
    {
      name: screens.content.drugsDiseases,
      component: LazyDrugsDiseases,
    },
    {
      name: screens.content.drugsDiseasesDetails,
      component: LazyDrugsDiseasesDetails,
    },
    {
      name: screens.content.medicalUpdates,
      component: LazyAllTopics,
    },
    {
      name: screens.content.genioChatRoutes,
      component: ChatRoutes,
      options: {
        headerShown: false,
      },
    },
    {
      name: screens.content.clinicalCaseRoutes,
      component: ClinicalCaseRoutes,
      options: {
        headerShown: false,
      },
    },
  ]);

export const drawerRoutes: DrawerItem[] = [
  {
    name: screens.homeTabs,
    component: HomeRoutes,
    options: {
      headerShown: false,
    },
    iconName: 'homeMenu',
  },
  // {
  //   name: screens.content.patientsRoutes,
  //   component: PatientsRoutes,
  //   iconName: 'erh',
  // },
  // {
  //   name: screens.content.customizeHome,
  //   component: CustomizeHome,
  //   options: {
  //     headerShown: true,
  //   },
  //   iconName: 'customizeHome',
  // },
  {
    name: screens.content.chooseYourSpeciality,
    isSubScreen: true,
    component: EmptyRoutes,
    options: {
      headerShown: false,
    },
    iconName: 'specialtyMenu',
  },
  // {
  //   name: screens.content.privacyPolicy,
  //   component: EmptyRoutes,
  //   iconName: 'privacyPolicyMenu',
  // },
  // {
  //   name: screens.content.privacyPolicyForm,
  //   component: EmptyRoutes,
  //   iconName: 'privacyPolicyFormMenu',
  // },
  // {
  //   name: screens.content.termsConditions,
  //   component: EmptyRoutes,
  //   iconName: 'termsConditionsMenu',
  // },
  {
    name: screens.content.settings,
    component: EmptyRoutes,
    isSubScreen: true,
    iconName: 'settingsMenu',
  },
  {
    name: screens.content.customerSupport,
    component: EmptyRoutes,
    isSubScreen: true,
    iconName: 'customerSupportMenu',
  },
  {
    name: screens.content.logout,
    component: EmptyRoutes,
    options: {},
    iconName: 'logout',
  },
];
